<template>
    <section class="app-section" :class="classes" :style="backgroundImageStyle">
        <slot />
    </section>
</template>

<script>
import './app-section.scss';

export default {
    name: 'AppSection',
    __editor: {
        fields: {
            backgroundColor: {
                widget: 'select',
                values: ['white', 'black', 'grey', 'primary', 'secondary'],
            },
            topPadding: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large', 'x-large', 'xx-large'],
            },
            bottomPadding: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large', 'x-large', 'xx-large'],
            },
            fillHeight: {
                widget: 'checkbox',
            },
        },
    },
    props: {
        backgroundImage: {
            type: String,
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
        },
        topPadding: {
            type: String,
            required: false,
            default: 'medium',
        },
        bottomPadding: {
            type: String,
            required: false,
            default: 'medium',
        },
        fillHeight: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        classes() {
            let classes = [
                `app-section--${this.backgroundColor}`,
                `app-section-top-padding--${this.topPadding}`,
                `app-section-bottom-padding--${this.bottomPadding}`,
            ];
            if (this.fillHeight) classes.push('app-section--fill-height');

            return classes;
        },
        backgroundImageStyle() {
            return this.backgroundImage
                ? {
                      backgroundImage: `url(${this.backgroundImage})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'bottom',
                  }
                : null;
        },
    },
};
</script>
